import { createI18n } from 'vue-i18n';
import fr from '../locales/fr.json';
import en from '../locales/en.json';
import nl from '../locales/nl.json';

const supported = ['fr', 'en', 'nl'] as const;
type Locale = (typeof supported)[number];

const getInitialLocale = (): Locale => {
  if (typeof window === 'undefined') return 'fr';
  const saved = localStorage.getItem('locale');
  if (saved && (supported as readonly string[]).includes(saved)) {
    return saved as Locale;
  }
  const nav = navigator.language?.split('-')[0] ?? 'fr';
  if ((supported as readonly string[]).includes(nav)) {
    return nav as Locale;
  }
  return 'fr';
};

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'fr',
  messages: {
    fr,
    en,
    nl,
  },
});

export default i18n;
